export const environment = {
  production: false,
  baseUrl: '/iimapi/v1'
};
